const filterProds = (currentStep, setSteps, setFProducts, setIsLoading) => {
    let filteredProducts = currentStep.data;

    setSteps(prevSteps => {
        let stepsAct = prevSteps;

        if(currentStep.tag === 'cpu' && stepsAct.find(step => step.tag === 'mother').data) {
            filteredProducts = filterAttr(filteredProducts, 'socket', findValue(stepsAct, 'mother', 'socket'));
        }

        if(currentStep.tag === 'mother') {

            if(stepsAct.find(step => step.tag === 'cpu').data) {
                filteredProducts = filterAttr(filteredProducts, 'socket', findValue(stepsAct, 'cpu', 'socket'));
            }

            if(stepsAct.find(step => step.tag === 'ram').data) {
                filteredProducts = filterAttr(filteredProducts, 'tecnologia', findValue(stepsAct, 'ram', 'tecnologia'));
            }

            if(stepsAct.find(step => step.tag === 'cpu').data && stepsAct.find(step => step.tag === 'ram').data) {
                filteredProducts = filterAttr(filteredProducts, 'socket', findValue(stepsAct, 'cpu', 'socket'), 'tecnologia', findValue(stepsAct, 'ram', 'tecnologia'));
            }

        }
        
        if(currentStep.tag === 'ram' && stepsAct.find(step => step.tag === 'mother').data) {
            filteredProducts = filterAttr(filteredProducts, 'tecnologia', findValue(stepsAct, 'mother', 'tecnologia'));
        }

        let actData = stepsAct.find(step => step.tag === currentStep.tag).data;

        if(actData) {
            filteredProducts = filteredProducts.sort((a, b) => {
                if(a.id === actData.id && b.id !== actData.id) return -1;
                if(!a.id !== actData.id && b.id === actData.id) return 1;
                return 0;
            });
        }
        else filteredProducts.sort((a, b) => a.price - b.price);

        filteredProducts = filteredProducts.sort((a, b) => {
            if(a.compatible && !b.compatible) return -1;
            if(!a.compatible && b.compatible) return 1;
            return 0;
        })

        setFProducts({ id: currentStep.category_id, data: filteredProducts });

        setTimeout(() => {
            setIsLoading(false);
        }, 150);
        
        return prevSteps;
    });
}

const filterAttr = (array, attrName, attrValue, attrName2, attrValue2) => {
    array = array.map(prod => {
        // Todavia no hay atributos (features) cargados en WooCommerce: no marcamos
        // nada como "no compatible" hasta que esos datos existan.
        if(!prod.features) return prod;

        let compatible = prod.features.find(attr => attr.name === attrName)?.value === attrValue;

        if(attrName2 && attrValue2) {
            compatible = compatible && prod.features.find(attr => attr.name === attrName2)?.value === attrValue2;
        }

        return {
            ...prod,
            compatible: compatible
        }
    })

    return array;
}

const findValue = (array, tag, attrName) => {
    return array.find(el => el.tag === tag)?.data?.features?.find(f => f.name === attrName)?.value;
}

export default filterProds;